import { render } from "./IconTrash.vue?vue&type=template&id=1b02b9f5"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/16/IconTrash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b02b9f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b02b9f5', __exports__)) {
    api.reload('1b02b9f5', __exports__)
  }
  
  module.hot.accept("./IconTrash.vue?vue&type=template&id=1b02b9f5", () => {
    api.rerender('1b02b9f5', render)
  })

}


export default __exports__